<template>
  <span>
    <!-- Go to Top -->
    <a
      class="js-go-to go-to position-fixed"
      href="javascript:;"
      style="visibility: hidden;"
      data-hs-go-to-options="{
        &quot;targetSelector&quot;: &quot;#main&quot;,
        &quot;compensationSelector&quot;: &quot;#logoAndNav&quot;,
        &quot;offsetTop&quot;: 700,
        &quot;position&quot;: {
          &quot;init&quot;: {
            &quot;right&quot;: 15
          },
          &quot;show&quot;: {
            &quot;bottom&quot;: 15
          },
          &quot;hide&quot;: {
            &quot;bottom&quot;: -15
          }
        }
      }"
    >
      <i class="fas fa-angle-up" />
    </a>
  <!-- End Go to Top -->
  </span>
</template>

<script>
const $ = require('jquery')
import HSGoTo from '@/assets/vendor/hs-go-to/src/js/hs-go-to'
export default {
  name: 'GoToTopButton',
  components: {
  },
  props: {
    list: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    }
  },
  async mounted() {
    $('.js-go-to').each(function() {
      new HSGoTo($(this)).init()
    })
  }
}
</script>
<style lang="scss" scoped>
// @import '~slick-carousel/slick/slick.css';
</style>
